// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"search-input-view_searchInput__3f51z","iconWrapper":"search-input-view_iconWrapper__3o_TG","input":"search-input-view_input__3uiDR"};